var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-avatar',_vm._b({attrs:{"color":_vm.userColor}},'v-avatar',_vm.$attrs,false),[_c('span',{staticClass:"white--text text-h6"},[_vm._v(" "+_vm._s((_vm.name ? _vm.name[0] : '').toUpperCase())+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }